import './App.css';
import React, { Component } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import * as firebaseui from 'firebaseui';
import {Settings, LockOpen, BuildTwoTone} from '@material-ui/icons';

import * as AuthServ from './services/AuthService';
import { Typography, Button, MuiThemeProvider, createTheme } from '@material-ui/core';
// import LockOpen from '@material-ui/icons/LockOpen';
import MainFrame from './MainFrame';
import RegisterMe from './components/RegisterMe';
import LogoRender from './components/LogoRender';
// const signInSuccessUrl = 'http://localhost:3000';

let search = window.location.search;
const params = new URLSearchParams(search);
const operation = params.get('op');
var client_id = "", response_type = "", redirect_uri = "", state = "", scope = "";
let login_only = false;
if (operation === 'ldp_login'){
  login_only = true;
  client_id = params.get('client_id');
  response_type = params.get('response_type');
  redirect_uri = params.get('redirect_uri');
  state = params.get('state');
  scope = params.get('scope');
  // console.log('client_id :>> ', client_id);
  // console.log('response_type :>> ', response_type);
  // console.log('redirect_uri :>> ', redirect_uri);
  // console.log('state :>> ', state);
  // console.log('scope :>> ', scope);
}

const productionFlag = true;

const firebaseConfig = {
  apiKey: "AIzaSyCd6USwl8noadSwhcNs7lcq54si-3-v0IA",
  authDomain: "autozone-tms.firebaseapp.com",
  projectId: "autozone-tms",
  appId: "1:1675627481:web:d502c47e9eb202d27b27c8"
};

// Configure FirebaseUI - depending on purposes of login...
var uiConfig = {};

if (login_only){

  uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // firebase.auth.GithubAuthProvider.PROVIDER_ID,
      {provider: firebase.auth.EmailAuthProvider.PROVIDER_ID, requireDisplayName: false}
    ],
    // signInSuccessUrl: signInSuccessUrl,
    callbacks: {
        signInSuccessWithAuthResult: () => {
          //hide ui div again
          document.getElementById('firebaseui-auth-container').style.display = 'none';
          return true;
        },
        uiShown: function() {
          // The widget is rendered.
          // show the ui div
          document.getElementById('firebaseui-auth-container').style.display = 'flex';
        }
    },
    // Terms of service url.
    tosUrl: '<your-tos-url>',
    // Privacy policy url.
    privacyPolicyUrl: '<your-privacy-policy-url>'
  };
} else {
  uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // firebase.auth.GithubAuthProvider.PROVIDER_ID,
      {provider: firebase.auth.EmailAuthProvider.PROVIDER_ID, requireDisplayName: false}
    ],
    // signInSuccessUrl: signInSuccessUrl,
    callbacks: {
        signInSuccessWithAuthResult: () => {
          //hide ui div again
          document.getElementById('firebaseui-auth-container').style.display = 'none';
          return true;
        },
        uiShown: function() {
          // The widget is rendered.
          // show the ui div
          document.getElementById('firebaseui-auth-container').style.display = 'flex';
        }
    },
    // Terms of service url.
    tosUrl: '<your-tos-url>',
    // Privacy policy url.
    privacyPolicyUrl: '<your-privacy-policy-url>'
  };
}

var ui;

//initialise FB and declare ui
if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

ui = new firebaseui.auth.AuthUI(firebase.auth());

if (!firebase) {throw new Error('unable to initialise firebase client sdk')}

// const ui = new firebaseui.auth.AuthUI(firebase.auth());

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      show_ui: false,
      signing_in: false,
      signed_in: false,
      user: {},
      gwt: null,
      error: null,
      forbidden: false,
      registered: false,
      just_registered: false,
      admin: false,
      super_admin: false,
      rom: false,
      rom_code: "",
      employee_number: "",
      employee_name: "",
      job_title: "",
      branch: '',
      local_auth: false,
    }
  }

  appTheme = createTheme({
    palette: {
      primary: {
          main: '#006e7a'
      },  
      secondary: {
        main: '#c20430'
      }
    }
  });

  componentDidMount = () => {
    try {

      if (productionFlag&&login_only){
        //Make sure user is signed out first...
        this.signOut();

        //Check that all required parms were received...
        if (!client_id||!response_type||!redirect_uri||!state||!scope){
          console.log('bad_request: missing get parameter(s) from ldp oauth request');
          this.setState({error:true,loading:false});
          return;
        }
        if (client_id!=="autozone_ldp"||response_type!=="code"||redirect_uri!=="https://autozonetalent.training/admin/oauth2callback.php"){
          console.log('bad_request: invalid client_id and/or response_type request and/or redirect_uri');
          this.setState({error:true,loading:false});
          return;
        }

        this.authListener = firebase.auth().onAuthStateChanged(async (user) => {
          // console.log('authentication state changed...');
          // console.log('state changed : user :>> ', user);
          if (user) {
            
            this.setState({loading:false,signing_in:true});
            const idToken = await user.getIdToken();

            const oauthPayload = {
              client_id: client_id,
              response_type : response_type,
              redirect_uri : redirect_uri,
              state : state,
              scope : scope
            }

            AuthServ.authorise(idToken,true,oauthPayload)
            .then(auth_response => {
              // console.log('Auth complete.');
              // console.log('auth_response :>> ', auth_response);
              if (auth_response.error){
                console.log('auth_response.error :>> ', auth_response.error);
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  rom: false,
                  admin: false,
                  super_admin: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: auth_response.error.message
                });
                firebase.auth().signOut();
              } else if (auth_response.Result !== "Success") {
                console.log('auth_response fail :>> ', auth_response);
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  admin: false,
                  super_admin: false,
                  rom: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: auth_response.Message
                });
                firebase.auth().signOut();
              } else if (auth_response.AccountStatus==='terminated'){
                console.log('Employment terminated.');
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  regsitered: true,
                  rom: false,
                  admin: false,
                  super_admin: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: 'Access to this service is no longer available.',
                  forbidden: true
                });
              } else if (auth_response.AccountStatus==='unregistered'){
                this.setState({
                  signed_in:true,
                  signing_in:false,
                  show_ui: false,
                  admin: false,
                  super_admin: false,
                  rom: false,
                  user: {
                    uid : user.uid,
                    displayName: user.displayName,
                    userEmail : user.email,
                  },
                  loading: false,
                  registered: false,
                  job_title: '',
                  gwt : auth_response.Gwt
                });
              } else if (auth_response.AccountStatus==='registered'){

                //*** This is where we redirect back to Oauth2!!! ***
                this.setState({signing_in:true,loading:false});

                // console.log('auth_response :>> ', auth_response);
                const auth_code = auth_response.Gwt;

                const full_redirect_uri = redirect_uri + '?state=' + encodeURIComponent(state) + '&scope=' + scope + '&code=' + auth_code;
                // console.log('Final URI :>> ',full_redirect_uri);

                window.location.replace(full_redirect_uri);

              } else {
                //invalid AccountStatus
                console.log('auth_response fail :>> ', auth_response);
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  admin: false,
                  super_admin: false,
                  rom: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: 'A technical error has been encountered. If this problem persists, please contact us.'
                });
              } 
            });
          } else {
            this.setState({
              signing_in:false,
              signed_in:false,
              admin: false,
              super_admin: false,
              rom: false,
              user:{},
              gwt: null,
              loading:false,
              job_title: ''
            });
          }
        });

        //Go straight to login ui...
        // this.launchLoginUi(); not anymore...

      } else if (productionFlag){
        //Note if we're working on a local dev server
        if (AuthServ.localServer()){this.setState({local_auth:true})}

        this.authListener = firebase.auth().onAuthStateChanged(async (user) => {
          // console.log('authentication state changed...');
          // console.log('state changed : user :>> ', user);
          if (user) {
            
            this.setState({loading:false,signing_in:true});
            const idToken = await user.getIdToken();

            AuthServ.authorise(idToken)
            .then(auth_response => {
              // console.log('Auth complete.');
              // console.log('auth_response :>> ', auth_response);
              if (auth_response.error){
                console.log('auth_response.error :>> ', auth_response.error);
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  rom: false,
                  admin: false,
                  super_admin: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: auth_response.error.message
                });
                firebase.auth().signOut();
              } else if (auth_response.Result !== "Success") {
                console.log('auth_response fail :>> ', auth_response);
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  admin: false,
                  super_admin: false,
                  rom: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: auth_response.Message
                });
                firebase.auth().signOut();
              } else if (auth_response.AccountStatus==='terminated'){
                console.log('Employment terminated.');
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  regsitered: true,
                  rom: false,
                  admin: false,
                  super_admin: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: 'Access to this service is no longer available.',
                  forbidden: true
                });
              } else if (auth_response.AccountStatus==='unregistered'){
                this.setState({
                  signed_in:true,
                  signing_in:false,
                  show_ui: false,
                  admin: false,
                  super_admin: false,
                  rom: false,
                  user: {
                    uid : user.uid,
                    displayName: user.displayName,
                    userEmail : user.email,
                  },
                  loading: false,
                  registered: false,
                  job_title: '',
                  gwt : auth_response.Gwt
                });
              } else if (auth_response.AccountStatus==='registered'){
                this.setState({
                  signed_in:true,
                  signing_in:false,
                  show_ui: false,
                  user: {
                    uid : user.uid,
                    displayName: user.displayName,
                    userEmail : user.email,
                  },
                  loading: false,
                  registered: true,
                  gwt : auth_response.Gwt,
                  admin: auth_response.Admin,
                  super_admin: auth_response.SuperAdmin,
                  rom: auth_response.ROM,
                  rom_code: auth_response.ROM_Code,
                  job_title: auth_response.JobTitle,
                  store_code: auth_response.StoreCode, 
                  employee_number: auth_response.EmployeeNumber,
                  employee_name: auth_response.EmployeeName
                });
              } else {
                //invalid AccountStatus
                console.log('auth_response fail :>> ', auth_response);
                this.setState({
                  signing_in:false,
                  signed_in:false,
                  show_ui: false,
                  admin: false,
                  super_admin: false,
                  rom: false,
                  user:{},
                  gwt: null,
                  loading:false,
                  job_title: '',
                  error: 'A technical error has been encountered. If this problem persists, please contact us.'
                });
              } 
            });
          } else {
            this.setState({
              signing_in:false,
              signed_in:false,
              admin: false,
              super_admin: false,
              rom: false,
              user:{},
              gwt: null,
              job_title: '',
              loading:false
            });
          }
        });
      }
    } catch (e){
        console.log('Error caught @ SignInPanel->cdm :>> ', e);
        this.setState({signed_in:false, signing_in:false,loading:false, user: {}, gwt: null, job_title: '', error: 'Authentication engine unavailable'});
    }

  };

  componentWillUnmount = () => {
    // console.log('Dismounting app...');
    if (productionFlag){this.authListener();} //effectively unsubscribes...
    if (ui){ui.delete();}
  };
  
  signOut = () => {
    this.setState({})
    firebase.auth().signOut();
  }

  launchLoginUi = () => {
    this.setState({show_ui:true});
    ui.start('#firebaseui-auth-container',uiConfig);
  }

  handleChildStateRequest = (new_state) => {
    this.setState(new_state);
  }

  newlyRegisteredOauthRedirect = () =>{
    const auth_code = this.state.gwt;
    const full_redirect_uri = redirect_uri + '?state=' + encodeURIComponent(state) + '&scope=' + scope + '&code=' + auth_code;
    window.location.replace(full_redirect_uri);
  }

  render() {
    return (
      <MuiThemeProvider theme={this.appTheme}>
      <div>

        {productionFlag&&
        <div>
          {this.state.loading&&
          <div className='pageContainer'>
            <div>
              <Settings className='icn-spinner' /> Loading...
            </div>
          </div>}

          {this.state.signing_in&&
          <div className='pageContainer'>
            <div>
              <Settings className='icn-spinner' /> Signing In...
            </div>
          </div>}

          {this.state.show_ui&&
          <div  style={{paddingTop:'25vh',marginBottom:25}}>
            <LogoRender az_qsv_banner={true}/>
          </div>}

          {!this.state.signed_in&&!this.state.show_ui&&!this.state.loading&&!login_only&&
          <div  className='pageContainer'>
            {/* <img src='autozone_logo.png' width='250px' alt='AutoZone'/> */}
            <LogoRender tms_logo={true} az_qsv_banner={true}/>
            <br/>
            {/* <h1>Welcome</h1> */}
            {/* <br/> */}
            Welcome to the AutoZone Talent Management System Portal
            <br/><br/>
            <Button onClick={this.launchLoginUi} variant={'contained'} color={'primary'}>
              <LockOpen />&nbsp;Staff member sign in
            </Button>
            <br/>
            {this.state.error&&!this.state.forbidden&&
            <Typography color='secondary'><br/>A technical error was encountered, and it was not possible to process your sign-in. If this problem persists, please contact us.</Typography>}
            {this.state.forbidden&&
            <Typography color='secondary'><br/>Access to this service is no longer available.</Typography>}
          </div>}

          {!this.state.signed_in&&!this.state.show_ui&&!this.state.loading&&login_only&&
          <div  className='pageContainer'>
            {/* <img src='autozone_logo.png' width='250px' alt='AutoZone'/> */}
            <LogoRender lms_logo={true}/>
            <br/>
            {/* <h1>Welcome</h1> */}
            {/* <br/> */}
            Welcome to the AutoXcel Learning Management System
            <br/><br/>
            <Button onClick={this.launchLoginUi} variant={'contained'} color={'primary'}>
              <LockOpen />&nbsp;Staff member sign in
            </Button>
            <br/>
            {this.state.error&&!this.state.forbidden&&
            <Typography color='secondary'><br/>A technical error was encountered, and it was not possible to process your sign-in. If this problem persists, please contact us.</Typography>}
            {this.state.forbidden&&
            <Typography color='secondary'><br/>Access to this service is no longer available.</Typography>}
            <Typography style={{width:'25%'}}>If you are <b>not</b> an existing AutoZone or QSV Staff Member and need to complete an <b>initial proficiency assessment</b> please <a href='https://autozonetalent.training/login/admin_and_guest.php'>click here</a></Typography>
          </div>}

          {this.state.signed_in&&!this.state.error&&!login_only&&
          <MainFrame
            signed_in={this.state.signed_in}
            user={this.state.user}
            signOut={this.signOut}
            registered={this.state.registered}
            gwt={this.state.gwt}
            admin={this.state.admin}
            super_admin={this.state.super_admin}
            rom={this.state.rom}
            rom_code={this.state.rom_code}
            job_title={this.state.job_title}
            store_code={this.state.store_code}
            employee_number={this.state.employee_number}
            employee_name={this.state.employee_name}
            setParentState={this.handleChildStateRequest}
            auth_local={this.state.local_auth}
          />}

          {this.state.signed_in&&!this.state.error&&login_only&&!this.state.registered&&
          <div className='pageContainer'>
            {/* <img src='autozone_logo.png' width='250px' alt='AutoZone'/> */}
            <LogoRender az_qsv_banner={true}/>
            <br/>
            <Typography color='primary'>This seems to be your first time logging with these credentials.</Typography>
            <RegisterMe
              signed_in={this.state.signed_in}
              user={this.state.user}
              signOut={this.signOut}
              registered={this.state.registered}
              gwt={this.state.gwt}
              admin={this.state.admin}
              super_admin={this.state.super_admin}
              rom={this.state.rom}
              rom_code={this.state.rom_code}
              job_title={this.state.job_title}
              employee_number={this.state.employee_number}
              employee_name={this.state.employee_name}
              setParentState={this.handleChildStateRequest}
              is_lms_login={login_only}
            />
          </div>}

          {this.state.signed_in&&!this.state.error&&login_only&&this.state.just_registered&&
          <div className='pageContainer'>
            {/* <img src='autozone_logo.png' width='250px' alt='AutoZone'/> */}
            <LogoRender lms_logo={true}/>
            <br/>
            <Typography color='primary'><b>Thank You!</b></Typography>
            <Typography color='primary' style={{width:'50%'}}>Your user account has been activated.</Typography>
            <br/>
            <Button onClick={this.newlyRegisteredOauthRedirect} variant={'contained'} color={'primary'}>Continue to AutoXcel</Button>
          </div>}

         

        </div>}

        {!productionFlag&&
        <div className='pageContainer'>
          <div>
            <BuildTwoTone className='icn-spinner' /> &nbsp; &nbsp; The AutoZone Talent Management System is undergoing some maintenance right now, but will be live again shortly...
          </div>
        </div>}

        {this.state.show_ui&&!this.state.signing_in&&!this.state.signed_in&&!this.state.loading&&!this.state.error&&
        <div style={{position:'absolute', bottom:15, width:'100%'}}>
          <Typography style={{width:'25%', marginLeft:'auto', marginRight:'auto'}}><small>Please Note: A valid email address is required in order to activate your profile. If you don't have an email address already, you can follow this <a href="https://support.google.com/accounts/answer/27441?hl=en" target='_blank' rel='noreferrer'>guide to create a free Google account</a> in order to get an email address.</small></Typography>
        </div>}
      
      </div>
      </MuiThemeProvider>    
    );
  }

 
}